import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import reports from './sidebarItems/reports';
import campaigns from './sidebarItems/campaigns';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import primaryMenu from './sidebarItems/primaryMenu';
import newReports from './sidebarItems/newReports';
import claudia from './sidebarItems/claudia';

export const getSidebarItems = (
  accountId,
  locale = 'pt_BR',
  claudiaOnly = false,
  flags = {}
) => ({
  primaryMenu: primaryMenu(accountId, locale, claudiaOnly),
  secondaryMenu: [
    conversations(accountId),
    contacts(accountId),
    reports(accountId, flags),
    campaigns(accountId),
    settings(accountId, claudiaOnly),
    notifications(accountId),
    newReports(accountId),
    claudia(accountId),
  ],
});
